import classNames from 'classnames';

import { PageWrapper } from 'pages/Workshop/PageWrapper';
import { CollapsibleTable } from 'pages/Workshop/common';

import styles from './styles.module.scss';

type TemplatesItemsTableType = {
  dataSource: any[];
  tableColumns: any;
  updateList?: Function;
  isDraggableTable?: boolean;
  className?: string;
};

export const TemplatesItemsTable = ({
  dataSource,
  tableColumns,
  updateList = () => {},
  isDraggableTable,
  className = '',
}: TemplatesItemsTableType) => {
  return (
    <PageWrapper
      pageWrapperContainerClassName={classNames(styles.trxTemplateTableWrapper, className)}
      isContainer={false}
    >
      <CollapsibleTable
        title=""
        dataSource={dataSource?.map((item, index) => ({ ...item, index }))}
        columns={tableColumns}
        disableCollapse
        isDraggableTable={isDraggableTable}
        customDragHandleUpdate={(activeId, overId, list) => updateList(activeId, overId, list)}
        customDraggingAllowedCondition={(activeRow, overRow) =>
          `${activeRow.Initial}${activeRow.Operator}${activeRow.DueDate}` ==
          `${overRow.Initial}${overRow.Operator}${overRow.DueDate}`
        }
      />
    </PageWrapper>
  );
};
